/**
 * Converts a given URL to use the current hostname and port.
 * @param url The original URL.
 * @returns The URL with the current hostname and port.
 */
export function convertUrlToCurrentHostname(url: string): string {
  const urlObject = new URL(url);
  urlObject.hostname = window.location.hostname;
  urlObject.port = window.location.port;
  return urlObject.href;
}

